/** A selected project can belong to another authorised workspace; never bill the header's stale workspace. */
import { useEffect, useState } from 'react';
import { useSI } from '../../contexts/SIContext';
import { fetchSIJson } from './siRequest';
export function useSIWorkspace(activeWorkspaceId: string | null | undefined, projectId: string | null | undefined) {
 const { readCached, writeCached } = useSI();
 const key = `workspace:${activeWorkspaceId ?? ''}:${projectId ?? ''}`;
 const [resolved, setResolved] = useState<{ key: string; workspaceId: string } | null>(() => {
  const workspaceId = readCached<string>(key, 30000); return workspaceId ? { key, workspaceId } : null;
 });
 useEffect(() => {
  const controller = new AbortController();
  const cached = readCached<string>(key, 30000);
  if (projectId && cached) { setResolved({ key, workspaceId: cached }); return () => controller.abort(); }
  setResolved(null);
  if (projectId) void fetchSIJson<{ workspaceId?: string }>(`/si/context?projectId=${encodeURIComponent(projectId)}`, { signal: controller.signal })
   .then(({ response, value }) => {
    if (!response.ok) throw new Error('Project workspace unavailable.');
    if (!controller.signal.aborted && typeof value.workspaceId === 'string') { writeCached(key, value.workspaceId); setResolved({ key, workspaceId: value.workspaceId }); }
   }).catch(() => {});
  return () => controller.abort();
 }, [projectId, activeWorkspaceId, key, readCached, writeCached]);
 return projectId ? resolved?.key === key ? resolved.workspaceId : null : activeWorkspaceId;
}
